import e from "@dialpad/dialtone-tokens/layered/themes/tokens-129-colors.css?inline";
//#region themes/129.js
var t = { brand: {
	css: e,
	name: "129"
} };
//#endregion
export { t as default };
